import { Button } from '@flos/react-ui';
import { FC } from 'react';

type PreviousButtonProps = {
    submitIsLoading: boolean;
    isLoading: boolean;
    onClick: () => void;
};

const PreviousButton: FC<PreviousButtonProps> = ({ isLoading, submitIsLoading, onClick }) => {
    const buttonText = 'Tilbage';

    return (
        <Button
            loadingText={buttonText}
            isLoading={isLoading}
            disabled={isLoading || submitIsLoading}
            onClick={onClick}
            size="medium"
            theme="ghost"
        >
            {buttonText}
        </Button>
    );
};

export default PreviousButton;
